// extracted by mini-css-extract-plugin
export default {"rightSide":"peopleTrains_rightSide__t5Mbi"};